import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';

import BusinessAbroadTermsBlockData from '../../../Models/Content/BusinessAbroadTermsBlockData';
import BusinessAbroadTermsMain from '../BusinessAbroadTermsBlock/BusinessAbroadTermsMain';

export default class BusinessAbroadTermsBlock extends EpiComponent<BusinessAbroadTermsBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <BusinessAbroadTermsMain context={this.getContext()} iContent={this.props.data} />;
  }
}
